<template>
  <router-view id="app" class="w-100"></router-view>
</template>

<script>
export default {
  name: 'app',
}
</script>
